/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Catch Backend
 * Catch Backend API
 * OpenAPI spec version: 0.1.0
 */

/**
 * Laboratory order status values
 */
export type OrderStatus = typeof OrderStatus[keyof typeof OrderStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderStatus = {
  patient_details_collected: 'patient_details_collected',
  psc_selected: 'psc_selected',
  order_created_pending_signature: 'order_created_pending_signature',
  requisition_created: 'requisition_created',
  sample_collected: 'sample_collected',
  sample_with_lab: 'sample_with_lab',
  partial_results: 'partial_results',
  completed: 'completed',
  processed: 'processed',
  cancelled: 'cancelled',
  failed: 'failed',
} as const;
